<template>
	<ul class="score-modifier-list">
		<li class="score-modifier" v-for="(modifier, scoreId) in score_modifiers" :key="scoreId">
			<div class="label">{{ $store.state.game.scores[scoreId].title }}</div>
			<div class="value" v-html="modifierString(modifier)" />
		</li>
	</ul>
</template>

<script>
export default {
	name: 'ScoreModifier',
	props: {
		score_modifiers: {
			type: Object,
			required: true,
		},
	},
	methods: {
		modifierString(modifier) {
			const string = Math.sign(modifier) === 1 ? `+${modifier * 100}` : modifier * 100;
			return string === 0 ? "&times;" : string;
		},
	},
};
</script>

<style lang="scss" scoped>
	.score-modifier-list { width: 80%; }

	.score-modifier {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: baseline;
		width: 100%;
		float: right;
		font-family: $body-font-alt;
		text-transform: uppercase;
		font-size: $font-size-sm;

		&::after {
			content: "";
			border-bottom: dotted .25ch $body-txt-color;
			flex: 1;
			order: 1;

			@include mobile { border-bottom: dotted .2ch $body-txt-color; }
		}

		.label { margin-right: .5ex; }

		.value {
			margin-left: .5ex;
			order: 2;
		}

		.trick-list.basic-grid & {
			@include mobile {
				display: flex;
				font-size: $font-size-xx-sm;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/game/shop/ScoreModifier.vue